import { HouseNightlyTripGlobalFieldFormProps } from '../components/form-container/HouseNightlyTripGlobalFormContainer'
import {
  HouseNightlyTripGlobal,
  HouseNightlyTripGlobalDto,
} from '../../../../../../../lib/graphql'
import {
  divideByFactor,
  multiplyByFactor,
} from '../../../../../../../utils/prices'

const computeInputPrice = (value: undefined | null | string | number) => {
  return value === '' || value === null || value === undefined
    ? null
    : multiplyByFactor(value)
}

export const computeHouseNightlyTripGlobalInputs = ({
  isEnabled,
  options,
}: HouseNightlyTripGlobalFieldFormProps): HouseNightlyTripGlobalDto => {
  const computedInputs: HouseNightlyTripGlobalDto = {
    isEnabled,
    options: {
      houseHold: options.houseHold.isIncluded
        ? null
        : {
            cleaningPrice: computeInputPrice(options.houseHold.cleaningPrice),
            laundryPrice: computeInputPrice(options.houseHold.laundryPrice),
            vatRate: options.houseHold.vatRate,
          },
      flexibleSchedule: {
        earlyCheckinPrice: computeInputPrice(
          options.flexibleSchedule.earlyCheckinPrice,
        ),
        lateCheckoutPrice: computeInputPrice(
          options.flexibleSchedule.lateCheckoutPrice,
        ),
        vatRate: options.flexibleSchedule.vatRate,
      },
      seasonalPrices: [
        {
          endAt: options.seasonalPrices[0].endAt,
          startAt: options.seasonalPrices[0].startAt,
          weekDay: {
            highPrice: computeInputPrice(
              options.seasonalPrices[0].weekDay.highPrice,
            ),
            lowPrice: computeInputPrice(
              options.seasonalPrices[0].weekDay.lowPrice,
            ),
            mediumPrice: computeInputPrice(
              options.seasonalPrices[0].weekDay.mediumPrice,
            ),
          },
          weekEnd: {
            highPrice: computeInputPrice(
              options.seasonalPrices[0].weekEnd.highPrice,
            ),
            lowPrice: computeInputPrice(
              options.seasonalPrices[0].weekEnd.lowPrice,
            ),
            mediumPrice: computeInputPrice(
              options.seasonalPrices[0].weekEnd.mediumPrice,
            ),
          },
        },
      ],
      vatRate: options.vatRate,
      touristTaxPrice: computeInputPrice(options.touristTaxPrice),
    },
  }

  return computedInputs
}

const computeDefaultValuePrice = (value: undefined | null | number) => {
  return value === null || value === undefined ? null : divideByFactor(value)
}

export const computeHouseNightlyTripGlobalDefaultValues = ({
  isEnabled,
  options,
}: HouseNightlyTripGlobal): HouseNightlyTripGlobalFieldFormProps => {
  const computedInputs: HouseNightlyTripGlobalFieldFormProps = {
    isEnabled,
    options: options
      ? {
          houseHold: options.houseHold
            ? {
                isIncluded: false,
                cleaningPrice: computeDefaultValuePrice(
                  options.houseHold.cleaningPrice,
                ),
                laundryPrice: computeDefaultValuePrice(
                  options.houseHold.laundryPrice,
                ),
                vatRate: options.houseHold.vatRate,
              }
            : {
                isIncluded: true,
                cleaningPrice: null,
                laundryPrice: null,
                vatRate: null,
              },
          flexibleSchedule: {
            earlyCheckinPrice: computeDefaultValuePrice(
              options.flexibleSchedule.earlyCheckinPrice,
            ),
            lateCheckoutPrice: computeDefaultValuePrice(
              options.flexibleSchedule.lateCheckoutPrice,
            ),
            vatRate: options.flexibleSchedule.vatRate,
          },
          seasonalPrices: [
            {
              endAt: options.seasonalPrices[0].endAt,
              startAt: options.seasonalPrices[0].startAt,
              weekDay: {
                highPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].weekDay.highPrice,
                ),
                lowPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].weekDay.lowPrice,
                ),
                mediumPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].weekDay.mediumPrice,
                ),
              },
              weekEnd: {
                highPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].weekEnd.highPrice,
                ),
                lowPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].weekEnd.lowPrice,
                ),
                mediumPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].weekEnd.mediumPrice,
                ),
              },
            },
          ],
          vatRate: options.vatRate,
          touristTaxPrice: computeDefaultValuePrice(options.touristTaxPrice),
        }
      : {
          flexibleSchedule: {
            earlyCheckinPrice: null,
            lateCheckoutPrice: null,
            vatRate: null,
          },
          seasonalPrices: [
            {
              endAt: null,
              startAt: null,
              weekDay: {
                highPrice: null,
                lowPrice: null,
                mediumPrice: null,
              },
              weekEnd: {
                highPrice: null,
                lowPrice: null,
                mediumPrice: null,
              },
            },
          ],
          vatRate: null,
          touristTaxPrice: null,
          houseHold: {
            isIncluded: true,
            cleaningPrice: null,
            laundryPrice: null,
            vatRate: null,
          },
        },
  }

  return computedInputs
}
